import { createContext } from 'react';

import type { FireFeedCardAnalyticsEvent } from '../useFeedCardAnalyticsEvents';

type FeedCardContextType = {
	fireAnalyticsEvent: FireFeedCardAnalyticsEvent;
};

export const FeedCardContext = createContext<FeedCardContextType>({
	fireAnalyticsEvent: () => {},
});
